import { css } from '@emotion/core'

export default ({ theme: { colors } }) => css`
  .title {
    text-transform: uppercase;
    font-weight: 600;
    display: block;
  }

  a {
    display: block;

    &:hover {
      text-decoration: underline;
    }

    &.active {
      color: ${colors.active};
    }
  }
`
